// Find Care mega-menu data — recreated from BookMyCarer_FindCare_Landing mockup
export const FIND_CARE_MENU = [
  {
    key: "elder", icon: "🧓", label: "Elder & Disability",
    title: "Elder & Disability Care",
    desc: "Compassionate in-home and community support for elderly individuals and people living with disability — delivered by verified carers.",
    modes: ["🏠 Home Visits", "🏥 At Clinic", "📱 Online / Tele"],
    note: "🪪 All carers Aadhaar-verified · AuthBridge credential checks · NDIS & Aged Care compliant",
    cta: "Browse Elder & Disability Carers",
    services: [
      { icon: "👴", name: "Elderly / Aged Care", tag: "Daily Living", t: "support" },
      { icon: "♿", name: "Disability Support Worker", tag: "NDIS", t: "support" },
      { icon: "📋", name: "Support Coordinator", tag: "NDIS", t: "support" },
      { icon: "🧩", name: "Behaviour Support Practitioner", tag: "Clinical", t: "clinical" },
      { icon: "🚗", name: "Mobility & Transport Support", tag: "Daily Living", t: "support" },
      { icon: "💛", name: "Elder Companion", tag: "Companionship", t: "support" },
      { icon: "🍽️", name: "Meal Preparation & Nutrition", tag: "Daily Living", t: "support" },
      { icon: "🏠", name: "Home Assistance", tag: "Daily Living", t: "support" },
      { icon: "👩‍⚕️", name: "Personal Care Attendant", tag: "Personal Care", t: "support" },
      { icon: "🧠", name: "Dementia Support", tag: "Specialist", t: "clinical" },
      { icon: "🌙", name: "Overnight / Live-In Care", tag: "Residential", t: "support" },
      { icon: "🏡", name: "Welfare Worker", tag: "Allied", t: "allied" },
    ],
  },
  {
    key: "nursing", icon: "💉", label: "Nursing & Clinical",
    title: "Nursing & Clinical Services",
    desc: "Qualified registered nurses, clinical practitioners and post-operative care specialists delivering regulated medical care at home or clinic.",
    modes: ["🏠 Home Visits", "🏥 At Clinic", "📱 Online / Tele"],
    note: "🏥 Ahpra-registered nurses · GNM / ANM qualified · Credential verified by AuthBridge",
    cta: "Browse Nursing & Clinical Carers",
    services: [
      { icon: "💉", name: "Registered Nurse (RN)", tag: "Ahpra Registered", t: "clinical" },
      { icon: "🏥", name: "Post-Operative Care", tag: "Clinical", t: "clinical" },
      { icon: "🩹", name: "Wound Care & Dressing", tag: "Clinical", t: "clinical" },
      { icon: "💊", name: "Medication Management", tag: "Clinical", t: "clinical" },
      { icon: "🩺", name: "Vital Signs Monitoring", tag: "Clinical", t: "clinical" },
      { icon: "🧬", name: "Medical Radiation Therapy", tag: "Ahpra Registered", t: "clinical" },
      { icon: "☢️", name: "Nuclear Medicine Technology", tag: "Ahpra Registered", t: "clinical" },
      { icon: "🔬", name: "Radiography", tag: "Ahpra Registered", t: "clinical" },
      { icon: "💊", name: "Pharmacy Services", tag: "Ahpra Registered", t: "clinical" },
      { icon: "🧪", name: "Genetic Counselling", tag: "Allied Health", t: "allied" },
      { icon: "🏡", name: "Home ICU / Critical Care", tag: "Specialist", t: "clinical" },
      { icon: "🩻", name: "IV Therapy & Cannulation", tag: "Clinical", t: "clinical" },
    ],
  },
  {
    key: "physio", icon: "🦽", label: "Physio & Speech",
    title: "Physio, Rehab & Speech Services",
    desc: "Accredited physiotherapists, occupational therapists, speech pathologists and rehabilitation specialists — at home, clinic or online.",
    modes: ["🏠 Home Visits", "🏥 At Clinic", "📱 Online / Tele"],
    note: "✅ Ahpra & NASRHP accredited professionals · Verified qualifications & registrations",
    cta: "Browse Physio & Rehab Carers",
    services: [
      { icon: "🦵", name: "Physiotherapy", tag: "Ahpra Registered", t: "clinical" },
      { icon: "🗣️", name: "Speech Pathology", tag: "NASRHP", t: "allied" },
      { icon: "🧑‍🦯", name: "Occupational Therapy", tag: "Ahpra Registered", t: "clinical" },
      { icon: "🏃", name: "Exercise Physiology", tag: "ESSA Accredited", t: "allied" },
      { icon: "👁️", name: "Orthoptics", tag: "Allied Health", t: "allied" },
      { icon: "🦿", name: "Orthotics & Prosthetics", tag: "NASRHP", t: "allied" },
      { icon: "👂", name: "Audiology", tag: "NASRHP", t: "allied" },
      { icon: "🦶", name: "Podiatry", tag: "Ahpra Registered", t: "clinical" },
      { icon: "🧘", name: "Diversional Therapy", tag: "Allied Health", t: "allied" },
      { icon: "🍏", name: "Nutrition & Dietetics", tag: "NASRHP", t: "allied" },
      { icon: "🧩", name: "Stroke Rehabilitation", tag: "Specialist", t: "clinical" },
      { icon: "🤸", name: "Post-Surgery Rehab", tag: "Clinical", t: "clinical" },
    ],
  },
  {
    key: "personal", icon: "🤝", label: "Personal & Daily Living Support",
    title: "Personal & Daily Living Support",
    desc: "Trusted non-medical support workers helping with everyday life — from personal hygiene to home management, errands and social connection.",
    modes: ["🏠 In-Home", "🌍 Community Access"],
    note: "🪪 Aadhaar-verified support workers · Background checked · Available daily, overnight & live-in",
    cta: "Browse Personal Support Carers",
    services: [
      { icon: "🛁", name: "Personal Hygiene & Grooming", tag: "Personal Care", t: "support" },
      { icon: "🛒", name: "Shopping & Errands", tag: "Daily Living", t: "support" },
      { icon: "🏡", name: "Domestic Assistance", tag: "Daily Living", t: "support" },
      { icon: "🍳", name: "Meal Preparation", tag: "Daily Living", t: "support" },
      { icon: "💛", name: "Companion & Social Support", tag: "Companionship", t: "support" },
      { icon: "🚗", name: "Transport & Mobility Assist", tag: "Daily Living", t: "support" },
      { icon: "💊", name: "Medication Reminders", tag: "Daily Living", t: "support" },
      { icon: "🌙", name: "Overnight Support", tag: "Residential", t: "support" },
      { icon: "👩‍👧", name: "Social Work", tag: "Allied Health", t: "allied" },
      { icon: "🏘️", name: "Community Welfare Worker", tag: "Allied Health", t: "allied" },
      { icon: "📚", name: "Skill Building & Independence", tag: "NDIS", t: "support" },
      { icon: "🧹", name: "Home Management Support", tag: "Daily Living", t: "support" },
    ],
  },
  {
    key: "mother", icon: "🍼", label: "Mother & Baby",
    title: "Mother & Baby Care",
    desc: "Specialist support for new mothers, newborns, infants and young children — from trained nurses and midwives to experienced childcare workers.",
    modes: ["🏠 Home Visits", "📱 Online / Tele"],
    note: "👶 Qualified maternity nurses, certified childcare workers & paediatric allied health",
    cta: "Browse Mother & Baby Carers",
    services: [
      { icon: "🤱", name: "Newborn Care Specialist", tag: "Baby Care", t: "support" },
      { icon: "🍼", name: "Babysitter", tag: "Child Care", t: "support" },
      { icon: "👶", name: "Childcare Worker / Nanny", tag: "Child Care", t: "support" },
      { icon: "💆‍♀️", name: "Postnatal Care & Support", tag: "Clinical", t: "clinical" },
      { icon: "🧸", name: "Child Life Therapy", tag: "Allied Health", t: "allied" },
      { icon: "🤸‍♀️", name: "Postnatal Exercise & Recovery", tag: "Allied Health", t: "allied" },
      { icon: "🍼", name: "Breastfeeding Support", tag: "Clinical", t: "clinical" },
      { icon: "🌙", name: "Night Nurse / Sleep Support", tag: "Baby Care", t: "support" },
      { icon: "🗣️", name: "Paediatric Speech Therapy", tag: "NASRHP", t: "allied" },
      { icon: "🧠", name: "Child Development Support", tag: "Allied Health", t: "allied" },
      { icon: "👩‍⚕️", name: "Maternity Nurse", tag: "Ahpra Registered", t: "clinical" },
      { icon: "🫁", name: "Paediatric Occupational Therapy", tag: "Ahpra Registered", t: "clinical" },
    ],
  },
  {
    key: "mental", icon: "🧠", label: "Mental Health & Counselling",
    title: "Mental Health & Counselling",
    desc: "Confidential mental health support from registered psychologists, counsellors and social workers — online, at home or at clinic.",
    modes: ["📱 Online / Tele", "🏠 Home Visits", "🏥 At Clinic"],
    note: "🔒 Confidential & safe · Ahpra-registered psychologists · PACFA / ACA counsellors · AASW social workers",
    cta: "Browse Mental Health Practitioners",
    services: [
      { icon: "🧠", name: "Psychology", tag: "Ahpra Registered", t: "clinical" },
      { icon: "💬", name: "Counselling", tag: "PACFA / ACA", t: "wellness" },
      { icon: "👩‍👧", name: "Social Work", tag: "AASW", t: "allied" },
      { icon: "🚨", name: "Mental Health Crisis Support", tag: "Sensitive", t: "sensitive" },
      { icon: "💙", name: "Trauma Support", tag: "Sensitive", t: "sensitive" },
      { icon: "🛡️", name: "Sexual Assault Support Worker", tag: "Sensitive", t: "sensitive" },
      { icon: "👴", name: "Elderly Mental Wellbeing", tag: "Wellbeing", t: "wellness" },
      { icon: "👨‍👩‍👧", name: "Family & Relationship Counselling", tag: "Counselling", t: "wellness" },
      { icon: "😟", name: "Anxiety & Depression Support", tag: "Counselling", t: "wellness" },
      { icon: "🌙", name: "Grief & Loss Counselling", tag: "Counselling", t: "wellness" },
      { icon: "🧩", name: "Behaviour Support", tag: "Allied Health", t: "allied" },
      { icon: "🎨", name: "Art Therapy", tag: "ANZACATA", t: "allied" },
    ],
  },
  {
    key: "pet", icon: "🐾", label: "Pet Care",
    title: "Pet Care Services",
    desc: "Loving, reliable pet care for your furry family members — from daily walks and grooming to overnight sitting and veterinary support coordination.",
    modes: ["🏠 At Your Home", "🌍 Community"],
    note: "🐾 Verified pet carers · Background checked · Special focus on companions for elderly & disability clients",
    cta: "Browse Pet Care Providers",
    services: [
      { icon: "🐕", name: "Dog Walking", tag: "Daily Care", t: "support" },
      { icon: "🏠", name: "Pet Sitting (at your home)", tag: "Daily Care", t: "support" },
      { icon: "🛁", name: "Pet Grooming", tag: "Grooming", t: "support" },
      { icon: "🌙", name: "Overnight Pet Care", tag: "Residential", t: "support" },
      { icon: "💊", name: "Medication Administration", tag: "Clinical", t: "clinical" },
      { icon: "🐱", name: "Cat Care & Sitting", tag: "Daily Care", t: "support" },
      { icon: "🚗", name: "Vet Transport & Escort", tag: "Transport", t: "support" },
      { icon: "🐾", name: "Pet Companionship (elderly)", tag: "Companion", t: "support" },
      { icon: "🎾", name: "Dog Training & Behaviour", tag: "Wellness", t: "wellness" },
      { icon: "🌿", name: "Pet Wellness Check", tag: "Wellness", t: "wellness" },
    ],
  },
  {
    key: "wellness", icon: "🌿", label: "Wellness & Lifestyle Services",
    title: "Wellness & Lifestyle Services",
    desc: "Low-regulation but high-impact wellness services — yoga, meditation, music therapy, art therapy and lifestyle coaching to support whole-person wellbeing.",
    modes: ["🏠 Home Visits", "📱 Online / Tele", "🌍 Community"],
    note: "🌿 Certified wellness practitioners · Music & art therapists peak-body registered · Available online & in-person",
    cta: "Browse Wellness Providers",
    services: [
      { icon: "🎵", name: "Music Therapy", tag: "AMTA Registered", t: "allied" },
      { icon: "🎨", name: "Art Therapy", tag: "ANZACATA", t: "allied" },
      { icon: "🧘", name: "Yoga & Mindfulness", tag: "Wellness", t: "wellness" },
      { icon: "🧘‍♂️", name: "Meditation Coaching", tag: "Wellness", t: "wellness" },
      { icon: "💪", name: "Wellness Coaching", tag: "Coaching", t: "wellness" },
      { icon: "🥗", name: "Nutrition Coaching", tag: "Wellness", t: "wellness" },
      { icon: "🏋️", name: "Personal Fitness Training", tag: "Fitness", t: "wellness" },
      { icon: "🫁", name: "Breathwork & Stress Relief", tag: "Wellness", t: "wellness" },
      { icon: "💆", name: "Remedial Massage", tag: "Wellness", t: "wellness" },
      { icon: "🌿", name: "Holistic Health Coaching", tag: "Coaching", t: "wellness" },
      { icon: "🎭", name: "Diversional Therapy", tag: "DRTA", t: "allied" },
      { icon: "🌸", name: "Lifestyle & Social Engagement", tag: "Lifestyle", t: "wellness" },
    ],
  },
];

export const TAG_STYLES = {
  clinical: { background: "#e3eeff", color: "#3a7bd5" },
  allied: { background: "#e3f5ec", color: "#3a8f5f" },
  support: { background: "#fef9e5", color: "#a07800" },
  wellness: { background: "#f0e8fc", color: "#7b35c7" },
  sensitive: { background: "#fde8e1", color: "#c04020" },
};
